module.exports = __webpack_public_path__ + "static/img/ikonaGimp-ON.32b35de5.png";